/**
 * @file: 云扫描活动
 * @author: wence
 */
import {rcAjax} from '../util';

export const getVoucher = params => rcAjax(
    'POST',
    '/xiapi/api/v1/pay/getOneClickVoucher',
    {},
    params,
    () => null
).then(data => data && data.data || {});

export const payVoucher = params =>
    rcAjax(
        'POST',
        '/xiapi/api/v1/pay/oneClickVoucher',
        {},
        params,
        () => null
    ).then(data => data && data.data || {});



// WEBPACK FOOTER //
// ./src/actions/activitySuAction.js